export * from "./kiosk";
export * from "./kioskErrors";
export * from "./api";
export * from "./loyalty";
export var ECouponViewType;
(function (ECouponViewType) {
    ECouponViewType["CAROUSEL"] = "carousel";
    ECouponViewType["NORMAL"] = "normal";
    ECouponViewType["IMAGE"] = "image";
})(ECouponViewType || (ECouponViewType = {}));
export var EProductKind;
(function (EProductKind) {
    EProductKind["GROUP"] = "3e/group";
    EProductKind["PRODUCT"] = "3e/product";
    EProductKind["CATEGORY"] = "3e/group/category";
    EProductKind["OPTIONS"] = "3e/group/options";
    EProductKind["CONFIG"] = "3e/group/config";
    EProductKind["STATIC"] = "3e/static";
    EProductKind["REF"] = "3e/ref";
    EProductKind["QUERY"] = "3e/query";
})(EProductKind || (EProductKind = {}));
export var EProductKindBucket;
(function (EProductKindBucket) {
    EProductKindBucket["GROUP"] = "group";
    EProductKindBucket["PRODUCT"] = "product";
})(EProductKindBucket || (EProductKindBucket = {}));
export var EOrderUserRole;
(function (EOrderUserRole) {
    EOrderUserRole["CREATOR"] = "CREATOR";
    EOrderUserRole["CUSTOMER"] = "CUSTOMER";
    EOrderUserRole["COUPON"] = "COUPON";
    EOrderUserRole["KIOSK"] = "KIOSK";
    EOrderUserRole["WAITER"] = "WAITER";
    EOrderUserRole["MANAGER"] = "MANAGER";
    EOrderUserRole["VIEWER"] = "VIEWER";
    EOrderUserRole["DRIVER"] = "DRIVER";
    EOrderUserRole["STAFF"] = "STAFF";
})(EOrderUserRole || (EOrderUserRole = {}));
// Update EOrderSource & EChannelName upon adding EOrderType
export var EOrderType;
(function (EOrderType) {
    EOrderType["TAKE_AWAY"] = "TAKE_AWAY";
    EOrderType["DELIVERY"] = "DELIVERY";
    EOrderType["DINE_IN"] = "DINE_IN";
    EOrderType["DINE_IN_OPEN"] = "DINE_IN_OPEN";
    EOrderType["GLOVO_DELIVERY"] = "GLOVO_DELIVERY";
    EOrderType["GLOVO_TAKE_AWAY"] = "GLOVO_TAKE_AWAY";
    EOrderType["JUSTEAT_DELIVERY"] = "JUSTEAT_DELIVERY";
    EOrderType["JUSTEAT_TAKE_AWAY"] = "JUSTEAT_TAKE_AWAY";
    EOrderType["UBER_DELIVERY"] = "UBER_DELIVERY";
    EOrderType["UBER_TAKE_AWAY"] = "UBER_TAKE_AWAY";
    EOrderType["UBER_DINE_IN"] = "UBER_DINE_IN";
    EOrderType["WOLT_DELIVERY"] = "WOLT_DELIVERY";
    EOrderType["WOLT_TAKE_AWAY"] = "WOLT_TAKE_AWAY";
    EOrderType["WOLT_DINE_IN"] = "WOLT_DINE_IN";
    EOrderType["BOLT_DELIVERY"] = "BOLT_DELIVERY";
    EOrderType["BOLT_TAKE_AWAY"] = "BOLT_TAKE_AWAY";
    EOrderType["BOLT_DINE_IN"] = "BOLT_DINE_IN";
    EOrderType["TAZZ_DELIVERY"] = "TAZZ_DELIVERY";
    EOrderType["TAZZ_TAKE_AWAY"] = "TAZZ_TAKE_AWAY";
    EOrderType["UPMENU_DELIVERY"] = "UPMENU_DELIVERY";
    EOrderType["UPMENU_TAKE_AWAY"] = "UPMENU_TAKE_AWAY";
    EOrderType["UPMENU_DINE_IN"] = "UPMENU_DINE_IN";
})(EOrderType || (EOrderType = {}));
export var EOrderSource;
(function (EOrderSource) {
    EOrderSource["KIOSK"] = "KIOSK";
    EOrderSource["WEB"] = "WEB";
    EOrderSource["JUST_EAT_TAKE_AWAY"] = "JUSTEATTAKEAWAY";
    EOrderSource["GLOVO"] = "GLOVO";
    EOrderSource["PYSZNE"] = "PYSZNE";
    EOrderSource["WOLT"] = "WOLT";
    EOrderSource["UBER"] = "UBER";
    EOrderSource["BOLT"] = "BOLT";
    EOrderSource["TAZZ"] = "TAZZ";
    EOrderSource["POS"] = "POS";
    EOrderSource["UPMENU"] = "UPMENU";
})(EOrderSource || (EOrderSource = {}));
export var EChannelName;
(function (EChannelName) {
    EChannelName["DINE_IN"] = "DINE_IN";
    EChannelName["TAKE_AWAY"] = "TAKE_AWAY";
    EChannelName["DELIVERY"] = "DELIVERY";
    EChannelName["GLOVO"] = "GLOVO";
    EChannelName["JUSTEAT"] = "JUSTEAT";
    EChannelName["UBER"] = "UBER";
    EChannelName["BOLT"] = "BOLT";
    EChannelName["WOLT"] = "WOLT";
    EChannelName["TAZZ"] = "TAZZ";
    EChannelName["UPMENU"] = "UPMENU";
})(EChannelName || (EChannelName = {}));
export var EOrderStatus;
(function (EOrderStatus) {
    EOrderStatus["NEW"] = "NEW";
    EOrderStatus["COMPLETED"] = "COMPLETED";
    EOrderStatus["VERIFIED"] = "VERIFIED";
    EOrderStatus["DELIVER"] = "DELIVER";
    EOrderStatus["DELIVERED"] = "DELIVERED";
    EOrderStatus["CLOSED"] = "CLOSED";
    EOrderStatus["ABANDONED"] = "ABANDONED";
    EOrderStatus["CANCELLED"] = "CANCELLED";
    EOrderStatus["PICKED"] = "PICKED";
})(EOrderStatus || (EOrderStatus = {}));
export var EOrderPaymentType;
(function (EOrderPaymentType) {
    EOrderPaymentType["CASH"] = "CASH";
    EOrderPaymentType["CARD"] = "CARD";
    EOrderPaymentType["COD"] = "COD";
    EOrderPaymentType["TERMINAL"] = "TERMINAL";
    EOrderPaymentType["EPAYMENT"] = "EPAYMENT";
    EOrderPaymentType["COUPON"] = "COUPON";
    EOrderPaymentType["WALLET"] = "WALLET";
    EOrderPaymentType["PREAUTHORIZED"] = "PREAUTHORIZED";
    EOrderPaymentType["RETURN"] = "RETURN";
    EOrderPaymentType["EXTERNAL"] = "EXTERNAL";
})(EOrderPaymentType || (EOrderPaymentType = {}));
export var ERbiOrderExtra;
(function (ERbiOrderExtra) {
    ERbiOrderExtra["POINTS_TOTAL"] = "x-rbi-loyalty-points";
    ERbiOrderExtra["POINTS_EARNED"] = "x-rbi-points-earned";
    ERbiOrderExtra["REWARDS"] = "x-rbi-rewards";
    ERbiOrderExtra["OFFERS"] = "x-rbi-offers";
    ERbiOrderExtra["CUSTOMER_NAME"] = "x-customer-name";
})(ERbiOrderExtra || (ERbiOrderExtra = {}));
export var EOrderLineStatus;
(function (EOrderLineStatus) {
    EOrderLineStatus["NEW"] = "NEW";
    EOrderLineStatus["TECHNICAL"] = "TECHNICAL";
    EOrderLineStatus["CONFIRMED"] = "CONFIRMED";
    EOrderLineStatus["PROCESSING"] = "PROCESSING";
    EOrderLineStatus["PROCESSED"] = "PROCESSED";
    EOrderLineStatus["VOID"] = "VOID";
    EOrderLineStatus["WASTE"] = "WASTE";
})(EOrderLineStatus || (EOrderLineStatus = {}));
export var EOrderProductKind;
(function (EOrderProductKind) {
    EOrderProductKind["GROUP"] = "group";
    EOrderProductKind["PRODUCT"] = "product";
})(EOrderProductKind || (EOrderProductKind = {}));
export const sizes = [
    48, 57, 70, 100, 160, 250, 300, 500, 600, 900, 1000, 1920, 1080, 900,
];
export var ENotificationType;
(function (ENotificationType) {
    ENotificationType["ORDER_EVENT_ERROR"] = "OrderEventError";
    ENotificationType["ORDER_APPLIED_EVENTS"] = "OrderAppliedEvents";
    ENotificationType["ORDER_EVENT_FISCAL"] = "OrderEventFiscal";
    ENotificationType["ORDER_UPSELL"] = "OrderUpsell";
})(ENotificationType || (ENotificationType = {}));
export const modules = [
    'POS_INTEGRATOR', 'KIOSK', 'BI_CONNECTOR', 'AGGREGATOR', 'KDS', 'STATUS_SCREEN', 'LOYALTY_INTEGRATOR', 'LOYALTY', 'MOBILE_APP_LOYALTY', 'ORDERING_WEB', 'DELIVERY_PANEL',
];
